<template lang="pug">
    .row
        .column.is-offset-1.is-10
            .row-publication
                .textbox
                    .title.is-5(v-if="opener && opener.title") {{ opener.title }}
                    .text(v-if="opener && opener.text" v-html="opener.text")
                    .infos(:class="{'is-hidden':!isCollapsed }")
                        div(v-if="isCollapsed" v-html="content.text")
                    a.readmore(v-if="content.text" @click="isCollapsed = !isCollapsed")
                        div(v-if="!isCollapsed" class="" icon="plus") Weiterlesen »
                        font-awesome-icon(v-if="isCollapsed" class="minus" icon="minus-square")
                .iconbox
                    router-link(
                        v-if="path"
                        :to="path"
                    )
                        Iconbox(v-if="icon" :link="link" :icon="icon")
                    a(
                        v-else-if="href"
                        :href="href"
                        :title="link.sub_title"
                        :target="target"
                    )
                        Iconbox(v-if="icon" :link="link" :icon="icon")
                    template(v-else)
                        Iconbox(v-if="icon" :link="link" :icon="icon")
</template>

<script>

import { get, startsWith } from 'lodash'

import Iconbox from './Iconbox'

export default {
    name: 'Publication',
    mounted() {
        if (this.id) {
          const state = this.getCollapseState();
          if (state) {
            this.isCollapsed = state[this.id];
          }
        }
    },
    data() {
        return {
            isCollapsed: false,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Iconbox,
    },
    computed: {
        contents() {
            return get(this.section, 'contents') || []
        },
        postsettings() {
            return get(this.section, 'settings') || []
        },
        opener() {
            return this.contents.find(content => content.key === 'opener')
        },
        link() {
            return this.contents.find(content => content.key === 'link')
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        settings() {
            return this.postsettings.find(settings => settings.key === 'settings')
        },
        icon() {
            const settings = get(this.link, 'settings') || []
            const icon = settings.find(settings => settings.key === 'symbol')
            return get(icon, 'value', 'calendar')
        },
        hyperlink() {
            return get(this.link, 'hyperlink') || {}
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! startsWith(link, 'https://') && ! startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
        linkText() {
            return get(this.hyperlink, 'name') || 'mehr...'
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins"
    .row
        display: flex
        .column
            padding-bottom: 20px
            border-bottom: 1px solid lightgrey
        .row-publication
            display: flex
            flex-direction: row
            +mobile
                flex-direction: column
                .textbox
                    margin-right: 0
                .iconbox
                    margin-top: 15px
                    flex-basis: 0
        .title
            margin-bottom: 1rem
        .infos
            padding-top: 25px
        .iconbox
            flex-basis: 225px
            flex-grow: 0
            flex-shrink: 0
        .textbox
            margin-right: 35px
            display: flex
            flex-grow: 1
            flex-direction: column
            .text
                position: relative
        .readmore
            font-weight: bold
            margin-top: 15px
            position: relative
            &:hover
                color: #80bb3d

</style>
